import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { GroupMemberRoleView } from '../../../../graphql/types.gen.ts';
import { useIsUserLoggedIn } from '../../../../helpers/useValidateToken.ts';
import { GENERAL_GROUP_NAME } from '../../../../index.tsx';
import { useLastGroupQuery } from '../../../FormPage/LoginPage/loginPage.gen.ts';
import {
	useGetLessonsWithHomeworkBySlugLazyQuery,
	useGetPublicLessonWithHomeworkBySlugLazyQuery,
	useLessonDeleteMutation,
} from '../../lessons.gen.ts';

export const useLesson = (titleId: string | undefined) => {
	const { isUserLoggedIn } = useIsUserLoggedIn();
	const navigate = useNavigate();
	const { data: chosenGroupData } = useLastGroupQuery({ skip: !isUserLoggedIn });
	const chosenGroup = chosenGroupData?.me?.recentlyUsedGroupId || GENERAL_GROUP_NAME;
	const [lessonDeleteMutation] = useLessonDeleteMutation();

	const [
		fetchPrivateLesson,
		{ data: privateLessonData, loading: privateLessonLoading, refetch: refetchPrivateLesson },
	] = useGetLessonsWithHomeworkBySlugLazyQuery({
		variables: {
			code: chosenGroup,
			lessonInput2: {
				slug: titleId,
			},
		},
	});
	const [fetchPublicLesson, { data: publicLessonData, loading: publicLessonLoading, refetch: refetchPublicLesson }] =
		useGetPublicLessonWithHomeworkBySlugLazyQuery({
			variables: {
				lessonInput2: {
					slug: titleId,
				},
			},
		});

	const lessonData = privateLessonData?.group || publicLessonData?.publicGroups?.[0];

	const refetchLesson = () => {
		if (isUserLoggedIn) {
			refetchPrivateLesson();
		} else {
			refetchPublicLesson();
		}
	};

	useEffect(() => {
		isUserLoggedIn ? fetchPrivateLesson() : fetchPublicLesson();
	}, [isUserLoggedIn]);

	const isInstructor = privateLessonData?.group?.me?.role === GroupMemberRoleView.Instructor || false;

	const deleteLesson = async () => {
		if (!isInstructor) return;
		lessonDeleteMutation({
			variables: {
				input: {
					groupCode: chosenGroup,
					lessonSlug: lessonData?.lesson?.slug,
				},
			},
		}).then((response) => {
			if (response.data.lessonDelete.__typename === 'LessonDeleteSuccessView') {
				navigate('/nauka');
			} else {
				toast.error('Nie udało się usunąć lekcji');
			}
		});
	};

	return {
		lesson: lessonData?.lesson,
		isInstructor,
		deleteLesson,
		isLoading: privateLessonLoading || publicLessonLoading,
		refetchLesson,
	};
};
